{
  "COMPOSE_REDIRECT": {
    "OPENING": "Opna nýtt samtal við {email}…",
    "NO_EMAIL": "Ekkert netfang gefið upp. Notaðu ?email=name@example.com",
    "CONTACT_ERROR": "Ekki tókst að finna tengilið fyrir {email}."
  },
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Vinsamlegast veldu samtal úr vinstri glugganum",
    "CSAT_REPLY_MESSAGE": "Vinsamlegast gefðu samtalinu einkun",
    "404": "Því miður finnum við ekki samtalið. Vinsamlegast reyndu aftur",
    "SWITCH_VIEW_LAYOUT": "Breyta uppsetningu",
    "DASHBOARD_APP_TAB_MESSAGES": "Skilaboð",
    "UNVERIFIED_SESSION": "Það er ekki búið að staðfesta einkenni þessa notanda",
    "NO_MESSAGE_1": "Uh ó! Svo virðist sem engin skilaboð séu frá viðskiptavinum í innhólfinu þínu.",
    "NO_MESSAGE_2": " til að senda skilaboð á síðuna þína!",
    "NO_INBOX_1": "Halló! Svo virðist sem þú hafir ekki bætt við neinum innhólfum ennþá.",
    "NO_INBOX_2": " til að byrja",
    "NO_INBOX_AGENT": "Uh Ó! Þú virðist ekki vera hluti af neinu innhólfi. Vinsamlegast hafðu samband við kerfisstjóra",
    "SEARCH_MESSAGES": "Leita að skilaboðum í samtölum",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Þýðing",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Leita í skilaboðum",
      "RESULT_TITLE": "Leitarniðurstöður",
      "LOADING_MESSAGE": "Vinn úr gögnum...",
      "PLACEHOLDER": "Sláðu inn texta til að leita í skilaboðum",
      "NO_MATCHING_RESULTS": "Engar niðurstöður fundust."
    },
    "UNREAD_MESSAGES": "Ólesin skilaboð",
    "UNREAD_MESSAGE": "Ólesið skilaboð",
    "CLICK_HERE": "Smelltu hér",
    "LOADING_INBOXES": "Hleð innhólfum",
    "LOADING_CONVERSATIONS": "Loading Conversations",
    "CANNOT_REPLY": "You cannot reply due to",
    "24_HOURS_WINDOW": "24 hour message window restriction",
    "NOT_ASSIGNED_TO_YOU": "Þetta samtal er ekki úthlutað á þig. Viltu úthluta þessu samtali á þig?",
    "ASSIGN_TO_ME": "Úthluta á mig",
    "TWILIO_WHATSAPP_CAN_REPLY": "Þú getur aðeins svarað þessu samtali með því að nota sniðmátskilaboð vegna þess að",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "24 hour message window restriction",
    "REPLYING_TO": "You are replying to:",
    "REMOVE_SELECTION": "Remove Selection",
    "DOWNLOAD": "Sækja",
    "UNKNOWN_FILE_TYPE": "Óþekkt skrá",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Áður en þú sendir, framkvæmdu:",
      "EXECUTE": "Framkvæma",
      "RETRY": "Reyna aftur",
      "CONFIRM": "Framkvæma núna?",
      "CONFIRM_YES": "Já, framkvæma",
      "CONFIRM_NO": "Hætta við",
      "RUNNING": "Í vinnslu…",
      "DONE": "Lokið",
      "CLAIM_DELAYED": "verður skráð þegar pöntunin hefur verið afhent",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "NÝ kvörtun {reference} var skráð, þar sem {planned} er lokuð — breyttu texta drögunum",
        "NEW_CLAIM": "NÝ kvörtun {reference} var skráð í stað þess að uppfæra {planned} — breyttu texta drögunum",
        "OTHER_CLAIM": "Kvörtun {reference} var uppfærð í stað {planned} — breyttu texta drögunum",
        "EXISTING_CLAIM": "Engin ný kvörtun var skráð, núverandi {reference} var uppfærð — breyttu texta drögunum",
        "OTHER": "Þetta fór öðruvísi en drögin gerðu ráð fyrir — breyttu texta drögunum"
      },
      "FAILED": "Mistókst",
      "UNREACHABLE": "Ekki náðist í bottann",
      "REQUEST_FAILED": "Ekki tókst að hefja aðgerðina, reyndu aftur.",
      "ACTIONS": {
        "CANCEL_ORDER": "Hættu við pöntunina",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Breyttu greiðslumáta í póstkröfu",
        "CREATE_CLAIM": "Skráðu kvörtun",
        "CREATE_OR_UPDATE_CLAIM": "Skráðu eða uppfærðu kvörtun",
        "EXTEND_ORDER_PICKUP_DATE": "Framlengdu frest til að sækja pöntunina"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Hleður upp viðhengi...",
    "REPLIED_TO_STORY": "Replied to your story",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Skilaboðum eytt",
    "FAIL_DELETE_MESSSAGE": "Gat ekki eytt skilaboðum! Reynið aftur",
    "NO_RESPONSE": "Ekkert svar",
    "RESPONSE": "Response",
    "RATING_TITLE": "Rating",
    "FEEDBACK_TITLE": "Endurgjöf",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Show labels",
      "HIDE_LABELS": "Hide labels"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Resolve",
      "REOPEN_ACTION": "Reopen",
      "OPEN_ACTION": "Open",
      "OPEN": "More",
      "CLOSE": "Close",
      "DETAILS": "details",
      "SNOOZED_UNTIL": "Snoozed until",
      "SNOOZED_UNTIL_TOMORROW": "Snoozed until tomorrow",
      "SNOOZED_UNTIL_NEXT_WEEK": "Snoozed until next week",
      "SNOOZED_UNTIL_NEXT_REPLY": "Snoozed until next reply",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      },
      "MORE": "More actions"
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Mark as pending",
      "SNOOZE_UNTIL": "Snooze",
      "SNOOZE": {
        "TITLE": "Snooze until",
        "NEXT_REPLY": "Next reply",
        "TOMORROW": "Tomorrow",
        "NEXT_WEEK": "Next week"
      },
      "RESOLVE_WITHOUT_CSAT": "Resolve without CSAT"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Snooze until",
      "APPLY": "Snooze",
      "CANCEL": "Hætta við"
    },
    "PRIORITY": {
      "TITLE": "Priority",
      "OPTIONS": {
        "NONE": "Enginn",
        "URGENT": "Áríðandi",
        "HIGH": "Hár",
        "MEDIUM": "Miðlungs",
        "LOW": "Lágur"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Enginn",
        "INPUT_PLACEHOLDER": "Select priority",
        "NO_RESULTS": "Engar niðurstöður fundust",
        "SUCCESSFUL": "Changed priority of conversation id {conversationId} to {priority}",
        "FAILED": "Couldn't change priority. Please try again."
      }
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Opna í nýjum flipa",
      "COPY_LINK": "Afrita tengil á samtal",
      "COPY_LINK_SUCCESS": "Tengill á samtal afritaður á klippiborð",
      "PENDING": "Mark as pending",
      "RESOLVED": "Mark as resolved",
      "MARK_AS_UNREAD": "Mark as unread",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Enduropna samtal",
      "SNOOZE": {
        "TITLE": "Snooze",
        "NEXT_REPLY": "Þar til að næsta svar berst",
        "TOMORROW": "Þar til á morgun",
        "NEXT_WEEK": "Þar til í næstu viku"
      },
      "ASSIGN_AGENT": "Assign agent",
      "ASSIGN_LABEL": "Assign label",
      "AGENTS_LOADING": "Loading agents...",
      "ASSIGN_TEAM": "Assign team",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Samtalsauðkenni {conversationId} úthlutað á „{agentName}“",
          "FAILED": "Couldn't assign agent. Please try again."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Couldn't assign label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Úthlutaði teymi #{team} á samtalsauðkenni {conversationId}",
          "FAILED": "Couldn't assign team. Please try again."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Message signature",
      "ENABLE_SIGN_TOOLTIP": "Enable signature",
      "DISABLE_SIGN_TOOLTIP": "Disable signature",
      "MSG_INPUT": "Shift + enter fyrir nýja línu. Byrjaðu á '/' til að velja tilbúið svar.",
      "PRIVATE_MSG_INPUT": "Shift + enter fyrir nýja línu. Þetta verður aðeins sýnilegt fyrir þjónustufulltrúa",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Skilaboðundirskrift er ekki stillt, vinsamlegast stilltu hana í prófílstillingum.",
      "CLICK_HERE": "Click here to update",
      "WHATSAPP_TEMPLATES": "Whatsapp Templates",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24 klukkustunda WhatsApp-glugginn er útrunninn. Svaraðu með sniðmáti.",
      "INSERT_SIGNATURE": "Insert signature into editor",
      "SIGNATURE_PREVIEW_IMAGE": "(image signature)"
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Svarið þitt virðist vera á {draftLanguage}, en þetta samtal er á {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Þýða",
      "REPLY": "Reply",
      "PRIVATE_NOTE": "Private Note",
      "SEND": "Send",
      "CREATE": "Add Note",
      "INSERT_READ_MORE": "Read more",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_FORMAT_ICON": "Show rich text editor",
      "HEADING_LEVEL": {
        "LABEL": "Textastíll",
        "NORMAL": "Venjulegur texti",
        "H1": "Fyrirsögn 1",
        "H2": "Fyrirsögn 2",
        "H3": "Fyrirsögn 3"
      },
      "EDITOR": {
        "BOLD": "Feitletrað",
        "ITALIC": "Skáletrað",
        "UNDERLINE": "Undirstrikað",
        "TEXT_COLOR": "Litur texta",
        "BG_COLOR_LABEL": "Bakgrunnslitur",
        "FONT_SIZE_LABEL": "Leturstærð",
        "FONT_SIZE": {
          "XS": "Lítið",
          "SM": "Frekar lítið",
          "MD": "Sjálfgefið",
          "LG": "Stórt",
          "XL": "Mjög stórt",
          "XXL": "Risastórt"
        },
        "CODE": "Kóði",
        "LINK": "Bæta við eða fjarlægja tengil",
        "CREATE_LINK": "Búa til tengil",
        "SAVE_LINK": "Vista",
        "CANCEL": "Hætta við",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Afturkalla",
        "REDO": "Endurtaka",
        "BULLET_LIST": "Punktalisti",
        "ORDERED_LIST": "Númeraður listi",
        "BLOCKQUOTE": "Tilvitnun",
        "H1": "Fyrirsögn 1",
        "H2": "Fyrirsögn 2",
        "H3": "Fyrirsögn 3",
        "IMAGE_UPLOAD": "Hlaða upp mynd",
        "CLEAR_FORMATTING": "Hreinsa snið",
        "COLOR": {
          "RED": "Rautt",
          "YELLOW": "Gult",
          "BLUE": "Blátt",
          "ROSE_RED": "Rósrautt",
          "DEEP_CYAN": "Djúpblágrænt",
          "ORANGE": "Appelsínugult",
          "PISTACHIO": "Pistasíugrænt",
          "PURPLE": "Fjólublátt",
          "FUCHSIA": "Fuksía",
          "SILVER": "Silfrað",
          "NAVY": "Dökkblátt",
          "OLD_PINK": "Gamalbleikt",
          "AQUA": "Sægrænt",
          "BROWN": "Brúnt",
          "OLIVE": "Ólífugrænt",
          "GOLD": "Gullið",
          "BEIGE": "Drapplitað",
          "WINE": "Vínrautt",
          "FOREST": "Skógargrænt",
          "GREEN": "Grænt",
          "BLUE_GREY": "Blágrátt",
          "RUBY_RED": "Rúbínrautt",
          "CHESTNUT_BROWN": "Kastaníubrúnt",
          "ASH_GREY": "Öskugrátt"
        },
        "BG_COLOR": {
          "RED": "Rautt",
          "YELLOW": "Gult",
          "BLUE": "Blátt",
          "ROSE_RED": "Rósrautt",
          "DEEP_CYAN": "Djúpblágrænt",
          "ORANGE": "Appelsínugult",
          "PISTACHIO": "Pistasíugrænt",
          "PURPLE": "Fjólublátt",
          "FUCHSIA": "Fuksía",
          "SILVER": "Silfrað",
          "NAVY": "Dökkblátt",
          "OLD_PINK": "Gamalbleikt",
          "AQUA": "Sægrænt",
          "BROWN": "Brúnt",
          "OLIVE": "Ólífugrænt",
          "GOLD": "Gullið",
          "BEIGE": "Drapplitað",
          "WINE": "Vínrautt",
          "FOREST": "Skógargrænt",
          "GREEN": "Grænt",
          "BLUE_GREY": "Blágrátt",
          "RUBY_RED": "Rúbínrautt",
          "CHESTNUT_BROWN": "Kastaníubrúnt",
          "ASH_GREY": "Öskugrátt"
        }
      },
      "TIP_EMOJI_ICON": "Show emoji selector",
      "TIP_ATTACH_ICON": "Bæta við viðhengjum",
      "TIP_AUDIORECORDER_ICON": "Taka upp hljóð",
      "TIP_AUDIORECORDER_PERMISSION": "Leyfa aðgang að hljóði",
      "TIP_AUDIORECORDER_ERROR": "Tókst ekki að opna hljóðið",
      "DRAG_DROP": "Dragðu og slepptu viðhenginu hingað",
      "START_AUDIO_RECORDING": "Hefja hljóðupptöku",
      "STOP_AUDIO_RECORDING": "Stoppa hljóðupptöku",
      "": "",
      "EMAIL_HEAD": {
        "TO": "TO",
        "ADD_BCC": "Bæta við bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Netföng aðskilin með kommum",
          "ERROR": "Vinsamlegast sláðu inn gilt netfang"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Netföng aðskilin með kommum",
          "ERROR": "Vinsamlegast sláðu inn gilt netfang"
        },
        "EDIT": "Edit",
        "EXPAND": "Cc/Bcc",
        "HIDE": "Hide",
        "INCLUDE_ORIGINAL_MESSAGE": "Include original message",
        "EDIT_HEADERS": "Edit",
        "HIDE_HEADER_EDITS": "Hide edits",
        "SUBJECT": {
          "LABEL": "SUBJECT",
          "PLACEHOLDER": "Email subject",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Undefined variables",
        "MESSAGE": "You have {undefinedVariablesCount} undefined variables in your message: {undefinedVariables}. Would you like to send the message anyway?",
        "CONFIRM": {
          "YES": "Send",
          "CANCEL": "Hætta við"
        }
      },
      "SEND_EMAIL": "Send email",
      "SEND_SMS": "Send SMS",
      "NO_SMS_INBOX": "Bættu við SMS innhólfi til að senda SMS svör.",
      "SEND_CHAT": "Send chat",
      "REPLY_TO_THIS": "Reply to this",
      "TIP_EXPAND_ICON": "Enlarge editor",
      "TIP_COLLAPSE_ICON": "Shrink editor",
      "COPILOT": {
        "Q": "Ask robot for help"
      }
    },
    "VISIBLE_TO_AGENTS": "Einkaglósa: Aðeins sýnilegt þér og teymi þínu",
    "CHANGE_STATUS": "Stöðu samtals breytt",
    "CHANGE_STATUS_FAILED": "Tókst ekki að breyta stöðu samtals",
    "CHANGE_AGENT": "Úthlutuðum þjónustufulltrúa samtals breytt",
    "CHANGE_AGENT_FAILED": "Tókst ekki að úthluta samtali",
    "ASSIGN_LABEL_SUCCESFUL": "Merki úthlutað",
    "ASSIGN_LABEL_FAILED": "Tókst ekki að úthluta merki",
    "CHANGE_TEAM": "Teymi samtals breytt",
    "FILE_SIZE_LIMIT": "Skráin fer framyfir hámarksstærð viðhengja ({MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE})",
    "MESSAGE_ERROR": "Ekki er hægt að senda þessi skilaboð, vinsamlegast reyndu aftur síðar",
    "SENT_BY": "Sent af:",
    "BOT": "Bot",
    "SEND_FAILED": "Tókst ekki að senda skilaboð! Reyndu aftur",
    "TRY_AGAIN": "reyna aftur",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Veldu Þjónustufulltrúa",
      "REMOVE": "Fjarlægja",
      "ASSIGN": "Úthluta"
    },
    "CONTEXT_MENU": {
      "COPY": "Afrita",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Eyða",
      "CREATE_A_CANNED_RESPONSE": "Bæta við stöðluðu svari",
      "TRANSLATE": "Translate",
      "COPY_PERMALINK": "Copy link to the message",
      "LINK_COPIED": "Message URL copied to the clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Are you sure you want to delete this message?",
        "MESSAGE": "You cannot undo this action",
        "DELETE": "Eyða",
        "CANCEL": "Hætta við"
      },
      "FORWARD": "Foward",
      "FORWARD_ERROR": "Failed to prepare forwarded message"
    },
    "SIDEBAR": {
      "CONTACT": "Contact",
      "COPILOT": "Copilot"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Samtal var merkt sem leyst af {userName}",
          "CONTACT_RESOLVED": "Samtal var leyst af {contactName}",
          "OPEN": "Conversation was reopened by {userName}",
          "PENDING": "Samtal var merkt sem í bið af {userName}",
          "SNOOZED": "Conversation was snoozed by {userName}",
          "AUTO_RESOLVED": "Samtal var merkt sem leyst af kerfinu vegna óvirkni í {duration} daga",
          "SYSTEM_AUTO_OPEN": "System reopened the conversation due to a new incoming message.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Conversation was marked resolved by {userName} (without CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Conversation was marked resolved by system due to {duration} hours of inactivity",
          "AUTO_RESOLVED_EMPTY": "Conversation was marked resolved by system due to being empty.",
          "BLOCKED_CONTACT_RESOLVED": "System resolved the conversation because the contact is blocked.",
          "KAUFLAND_TICKET_CLOSED": "Kerfið leysti samtalið vegna þess að miðanum var lokað á Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} set the priority to {newPriority}",
          "UPDATED": "{userName} changed the priority from {oldPriority} to {newPriority}",
          "REMOVED": "{userName} removed the priority"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} úthlutaði þessu samtali á sig",
          "ASSIGNED": "Úthlutað á {assigneeName} af {userName}",
          "REMOVED": "Conversation unassigned by {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Assigned to {teamName} by {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Úthlutað {assigneeName} í gegnum {teamName} af {userName}",
          "REMOVED": "Óúthlutað af {teamName} af {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} added {labels}",
          "REMOVED": "{userName} removed {labels}"
        },
        "SLA": {
          "ADDED": "{userName} added SLA policy {slaName}",
          "REMOVED": "{userName} removed SLA policy {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} has muted the conversation",
        "UNMUTED": "{userName} has unmuted the conversation",
        "CONTACT_BLOCKED": "{userName} lokaði á tengiliðinn",
        "CONTACT_UNBLOCKED": "{userName} aflétti lokun á tengiliðnum",
        "AUTO_RESOLUTION_MESSAGE": "Resolving the conversation as it has been inactive for a while. Please start a new conversation if you need further assistance.",
        "DOMAIN_BLOCKED": "{userName} blocked all contacts for a given domain",
        "DOMAIN_UNBLOCKED": "{userName} unblocked all the contacts for a given domain",
        "MOVED": "{userName} moved this conversation from inbox {sourceInboxName} to inbox {targetInboxName}",
        "MOVED_BY_ORDER": "Fært þar sem pantanir tengiliðarins koma aðeins frá versluninni {storeName} (síðasta pöntun {orderId}), en vélmenni hennar svarar í þessu pósthólfi.",
        "MERGED": "{userName} merged conversation #{sourceId} into this conversation",
        "AUTOMATION_RULE_TRIGGERED": "Automation rule \"{ruleName}\" triggered",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Automation rule \"{ruleName}\" disabled automatic priority",
        "AUTOMATION_SKIP_AUTO_LABELING": "Automation rule \"{ruleName}\" disabled automatic labeling",
        "AUTOMATION_STOP_PROCESSING_RULES": "Automation rule \"{ruleName}\" stopped further rule processing",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Sending message action was skipped for this auto-reply message",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Sjálfvirkni var sleppt því tengiliðurinn er útilokaður",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Sjálfvirknireglan \"{ruleName}\" gat ekki fært þetta samtal úr innhólfinu {sourceInboxName} í innhólfið {targetInboxName} vegna þess að innhólfin eru ekki samhæf.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Sjálfvirknireglan \"{ruleName}\" gat ekki fært þetta samtal úr innhólfinu {sourceInboxName} í innhólfið {targetInboxName} vegna þess að tengiliðurinn er ekki með netfang.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Sjálfvirknin \"{ruleName}\" gat ekki sent skilaboð: þetta símainnhólf getur ekki sent SMS því reikningurinn er ekki með SMS-innhólf. Slökkt var á reglunni og stjórnendur fengu tölvupóst.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Sjálfvirknin \"{ruleName}\" gat ekki sent skilaboð: ekki er hægt að senda viðhengi með SMS úr þessu innhólfi. Slökkt var á reglunni og stjórnendur fengu tölvupóst.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Macro \"{macroName}\" sendi ekki skilaboðin sín: þetta símainnhólf getur ekki sent SMS því reikningurinn er ekki með SMS-innhólf.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Macro \"{macroName}\" sendi ekki skilaboðin sín: ekki er hægt að senda viðhengi með SMS úr þessu innhólfi.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Macro \"{macroName}\" sendi ekki skilaboðin sín: spjallmennið sér um þetta samtal. Opnaðu samtalið fyrst.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Macro \"{macroName}\" sendi ekki skilaboðin sín: þetta innhólf er merkt til eyðingar. Færðu samtalið fyrst í annað innhólf.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Sjálfvirknireglan \"{ruleName}\" sendi tölvupóst á {contactEmail} í nýju samtali [#{conversationId}]({conversationPath}) í innhólfinu {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Sjálfvirknireglan \"{ruleName}\" hóf þetta samtal vegna samtals [#{conversationId}]({conversationPath}) í innhólfinu {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Sjálfvirknireglan \"{ruleName}\" gat ekki sent skilaboðin í nýju samtali í innhólfinu {inboxName} vegna þess að tengiliðurinn er ekki með netfang.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Sjálfvirknireglan \"{ruleName}\" sendi SMS á {contactPhone} í nýju samtali [#{conversationId}]({conversationPath}) í innhólfinu {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Sjálfvirknireglan \"{ruleName}\" gat ekki sent SMS í nýju samtali í innhólfinu {inboxName} vegna þess að tengiliðurinn er ekki með símanúmer.",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Þjónustufulltrúi",
            "CUSTOMER": "Viðskiptavinur"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "svarað annars staðar, hringdi í {duration}",
            "NO_ANSWER": "ósvarað, hringdi í {duration}",
            "REJECTED": "hafnað eftir að hafa hringt í {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Leyst sjálfkrafa eftir misheppnaðar tilraunir til að hringja til baka: {count}",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Símtalaupptöku eytt af {name}, {date}"
        }
      }
    },
    "IMAGE_RESIZE": {
      "SMALL": "Small",
      "MEDIUM": "Medium",
      "LARGE": "Large",
      "ORIGINAL": "Original"
    },
    "SHOW_HIDDEN_MESSAGES": "Show hidden messages",
    "TRANSCRIPT": {
      "SHOW": "Show full transcript",
      "HIDE": "Hide full transcript",
      "DOWNLOAD": "Download transcript",
      "COPY": "Copy transcript"
    },
    "INVISIBLE_TO_CUSTOMER": "Ósýnilegt viðskiptavini",
    "SENT_VIA_EMAIL": "Einnig sent til tengiliðar með tölvupósti ({time})",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "FACEBOOK_CANNOT_REPLY": "If you need to continue this conversation, ",
    "PENDING_WITH_BOT_BANNER": "This conversation is being handled by AI bot. If you want to reply, open the conversation first.",
    "INBOX_DELETE_REQUESTED_BANNER": "Þetta innhólf er merkt til eyðingar, þannig að svar viðskiptavinarins myndi aldrei berast. Færðu samtalið í annað innhólf til að svara.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Þessi tengiliður er með annað opið samtal #{id}",
      "MULTIPLE": "Þessi tengiliður er með önnur opin samtöl ({count})",
      "OPEN": "Opna",
      "SHOW": "Sýna"
    },
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won't be able to send messages from this conversation anymore.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Cannot send message because the customer is not online and email continuity is not available.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "The customer is not online. They may not receive messages since email continuity is not available.",
    "OPEN_FILE": "Open",
    "DOWNLOAD_ATTACHMENTS": "Download all",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Download all attachments one by one",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Download all as ZIP",
    "ERROR_DOWNLOADING_FILE": "Error downloading file",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Biðja viðskiptavininn um að deila WhatsApp símanúmerinu sínu",
      "PENDING_ACTION": "Beiðni um tengiliðaupplýsingar bíður",
      "STATES": {
        "PENDING": "Beðið eftir tengiliðaupplýsingum",
        "SHARED": "Símanúmeri deilt",
        "IDENTITY_CONFLICT": "Símanúmer þarfnast yfirferðar"
      }
    },
    "SLA": {
      "BREACHED": "breached"
    },
    "IMAGE_UPLOAD_ERROR": "Unable to upload image, please try again",
    "DRAFT": {
      "FILE_TOO_LARGE": "File '{fileName}' ({fileSize}) is too large for draft storage and will be skipped",
      "ATTACHMENT_SERIALIZATION_FAILED": "Failed to serialize attachment for draft storage",
      "STORAGE_QUOTA_EXCEEDED": "Storage quota exceeded. Draft saved without attachments",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Failed to save draft even without attachments",
      "SAVE_FAILED": "Failed to save conversation draft"
    },
    "COMMENT_TREE": {
      "TITLE": "Comment thread",
      "EMPTY": "No comments to display",
      "VIEW_TREE": "View comment thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Senda afrit af samtali",
    "DESC": "Sendu afrit af samtali á tilgreint netfang",
    "SUBMIT": "Senda",
    "CANCEL": "Hætta við",
    "SEND_EMAIL_SUCCESS": "Afritið af samtalinu var sent",
    "SEND_EMAIL_ERROR": "Það kom villa, vinsamlegas reyndu aftur",
    "FORM": {
      "SEND_TO_CONTACT": "Senda afritið á viðskiptavinin",
      "SEND_TO_AGENT": "Sendu afritið til úthlutaðs þjónustufulltrúa",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Sendu afritið á annað netfang",
      "EMAIL": {
        "PLACEHOLDER": "Sláðu inn netfang",
        "ERROR": "Vinsamlegast sláðu inn gilt netfang"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Velkomin/n á {installationName}!",
    "DESCRIPTION": "Takk fyrir að skrá þig. Við viljum að þú fáir sem mest út úr {installationName}. Hér eru nokkur atriði sem þú getur gert í {installationName} til að gera upplifunina ánægjulega.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Sjáðu nýjustu uppfærslurnar okkar",
    "ALL_CONVERSATION": {
      "TITLE": "Öll samtölin þin á einum stað",
      "DESCRIPTION": "Skoðaðu öll samtöl viðskiptavina þinna á einu mælaborði. Þú getur síað samtölin eftir innkominni rás, merkingu og stöðu.",
      "NEW_LINK": "Smelltu hér til að bæta við innhólfi"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Bjóða í teymið",
      "DESCRIPTION": "Þar sem þú ert að búa þig undir að tala við viðskiptavini þína skaltu fá samstarfsfélaga þína til að aðstoða þig. Þú getur boðið samstarfsfélögum þínum með því að bæta netföngum þeirra við þjónustufulltrúalistann.",
      "NEW_LINK": "Smelltu hér til að bjóða meðlim í teymið"
    },
    "LABELS": {
      "TITLE": "Flokkaðu samtöl með merkjum",
      "DESCRIPTION": "Merkingar eru auðveldari leið til að flokka samtalið þitt. Búðu til merki eins og #support-enquiry, #billing-question o.s.frv., svo þú getir notað þau í samtali síðar.",
      "NEW_LINK": "Smelltu hér til að búa til merki"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Úthlutaður Þjónustufulltrúi",
    "SELF_ASSIGN": "Úthluta á mig",
    "TEAM_LABEL": "Úthlutað Teymi",
    "SELECT": {
      "PLACEHOLDER": "Enginn"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Custom Data",
      "CONTACT_DETAILS": "Nánari Upplýsingar Tengiliðs",
      "CONVERSATION_ACTIONS": "Samtals Aðgerðir",
      "CONVERSATION_LABELS": "Merkingar Samtala",
      "CONVERSATION_INFO": "Samtals Upplýsingar",
      "CONTACT_ATTRIBUTES": "Contact Attributes",
      "PREVIOUS_CONVERSATION": "Fyrri samtöl",
      "MACROS": "Macros",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "ORDER_HISTORY": "Order History",
      "RETINO_TICKETS": "Retino Tickets"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Í bið",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Create attribute",
    "NO_RECORDS_FOUND": "Engir eiginleikar fundust",
    "UPDATE": {
      "SUCCESS": "Eiginleika breytt",
      "ERROR": "Ekki er hægt að uppfæra eigindina. Vinsamlegast reyndu aftur síðar"
    },
    "ADD": {
      "TITLE": "Bæta við",
      "SUCCESS": "Eiginleika bætt við",
      "ERROR": "Ekki er hægt að bæta við eigindi. Vinsamlegast reyndu aftur síðar"
    },
    "DELETE": {
      "SUCCESS": "Eiginleika eytt",
      "ERROR": "Ekki er hægt að eyða eigindinni. Vinsamlegast reyndu aftur síðar"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Bæta við eiginleikum",
      "PLACEHOLDER": "Leita í eiginleikum",
      "NO_RESULT": "Engir eiginleikar fundust"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "From",
    "TO": "Til",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subject"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Participating",
    "SIDEBAR_TITLE": "Conversation participants",
    "NO_RECORDS_FOUND": "Engar niðurstöður fundust",
    "ADD_PARTICIPANTS": "Select participants",
    "REMANING_PARTICIPANTS_TEXT": "+{count} others",
    "REMANING_PARTICIPANT_TEXT": "+{count} other",
    "TOTAL_PARTICIPANTS_TEXT": "{count} people are participating.",
    "TOTAL_PARTICIPANT_TEXT": "{count} person is participating.",
    "NO_PARTICIPANTS_TEXT": "No one is participating!.",
    "WATCH_CONVERSATION": "Join conversation",
    "YOU_ARE_WATCHING": "You are participating",
    "API": {
      "ERROR_MESSAGE": "Could not update, try again!",
      "SUCCESS_MESSAGE": "Participants updated!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "View translated content",
    "DESC": "You can view the translated content in each langauge.",
    "ORIGINAL_CONTENT": "Original Content",
    "TRANSLATED_CONTENT": "Translated Content",
    "NO_TRANSLATIONS_AVAILABLE": "No translations are available for this content"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Someone is typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "No data found",
    "LOAD_ERROR": "Unable to load data. Please try again later."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Load more",
    "NO_RECORDS_FOUND": "No tickets found",
    "LOAD_ERROR": "Unable to load tickets from {hookName}. Please try again later.",
    "NOT_SEARCHABLE": "Contact email is not set.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Loading...",
    "NO_ORDERS": "No orders found",
    "NOT_AVAILABLE": "Customer data not available",
    "EXPAND": "Open customer profile",
    "MORE_ITEMS": "+ {count} items",
    "EXPEDITION_STATUS": "Expedition status",
    "OPEN_DETAIL": "open detail",
    "COPY_ORDER_ID": "Pöntunarnúmer",
    "EXTERNAL_ID": "Ytra auðkenni",
    "PAYMENT_TYPE": "Greiðslumáti",
    "PAYMENT_DATE": "Greiðsludagur",
    "DELIVERY_PROVIDER": "Flutningsaðili",
    "EXPECTED_DATE_OF_DELIVERY": "Áætluð afhending",
    "DATE_OF_DELIVERY": "Afhent",
    "EXPEDITION_DATE": "Sendingardagur",
    "INTERNAL_NOTE": "Verslunarathugasemd",
    "PACKAGE_NUMBER": "Sending"
  },
  "READING": {
    "ONE": "{user} is reading this ticket",
    "TWO": "{user} and {secondUser} are reading this ticket",
    "MULTIPLE": "{user} and {count} others are reading this ticket"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Move Conversation",
    "DESCRIPTION": "Move this conversation to a different email inbox.",
    "SOURCE": {
      "TITLE": "Conversation",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Destination Inbox",
      "PLACEHOLDER": "Select an email inbox",
      "NO_RESULTS": "No other email inboxes available",
      "ERROR": "Please select a destination inbox"
    },
    "SUBMIT": "Move Conversation",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation moved successfully",
    "ERROR_MESSAGE": "Could not move conversation. Please try again."
  },
  "MERGE": {
    "TITLE": "Merge Conversations",
    "DESCRIPTION": "Merge this conversation with another conversation. All messages from this conversation will be moved to the target conversation, and this conversation will be deleted.",
    "SOURCE": {
      "TITLE": "Source Conversation (will be deleted)",
      "ID_LABEL": "Conversation ID"
    },
    "TARGET": {
      "TITLE": "Target Conversation",
      "PLACEHOLDER": "Type conversation ID to search (e.g., 123)",
      "HELP": "Enter the conversation ID to merge all messages into.",
      "ERROR": "Please select a target conversation"
    },
    "WARNING": "Warning: This action cannot be undone. All messages will be moved to the target conversation and this conversation will be permanently deleted.",
    "SUBMIT": "Merge Conversations",
    "CANCEL": "Cancel",
    "SUCCESS_MESSAGE": "Conversation merged successfully",
    "ERROR_MESSAGE": "Could not merge conversations. Please check the target conversation and try again.",
    "SEARCH": {
      "NO_RESULTS": "No conversation found with this ID",
      "ERROR_MESSAGE": "Could not search conversations. Please try again."
    },
    "CONFIRM": {
      "TITLE": "Confirm Merge",
      "DESCRIPTION": "Are you sure you want to merge this conversation? This action cannot be undone.",
      "YES": "Yes, Merge",
      "CANCEL": "Cancel"
    }
  }
}
